import { render, staticRenderFns } from "./GapsInCare.vue?vue&type=template&id=5ced5ce4&scoped=true"
import script from "./GapsInCare.vue?vue&type=script&lang=js"
export * from "./GapsInCare.vue?vue&type=script&lang=js"
import style0 from "./GapsInCare.vue?vue&type=style&index=0&id=5ced5ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced5ce4",
  null
  
)

export default component.exports